import { CompactUser } from "../../../../core/CompactModels"
import DataItem from "../../../../models/DataItem"
import PhoneItem from "../../../../models/PhoneItem"


export interface RedirectRuleRequestModel {
    id?: string
    name?: string
    description?: string
    phone?: PhoneItem
    dateType?: RedirectCallsDateTypes
    timezoneId?: string
    rangeDateFrom?: string
    rangeDateTo?: string
    weekDayFrom?: number
    weekDayTo?: number
    weekDayFromTime?: string
    weekDayToTime?: string
    repeatType?: RedirectCallsRepeatTypes
    repeatTill?: string
    extensionIds?: string[]
    queueIds?: string[]
}


export interface RedirectCallsItem {
    id?: string
    name?: string
    description?: string
    isActive?: boolean
    expired?: boolean
    phone?: PhoneItem
    phoneRaw?: string
    miskDestId?: string
    dateType?: RedirectCallsDateTypes
    dateTypeValue?: string
    timezoneId?: string
    rangeDates?: RedirectCallsRangeDateItem
    weekDayFrom?: number
    weekDayTo?: number
    weekDayFromTimeStr?: string
    weekDayToTimeStr?: string
    weekDayFromTime?: string
    weekDayToTime?: string
    weekState?: RedirectCallsWeekState
    repeatType?: RedirectCallsRepeatTypes
    repeatTill?: Date
    repeatTillText?: string
    extensionIds?: string[]
    extensions?: DataItem[]
    queueIds?: string[]
    queues?: DataItem[]
    ownerUserId?: string
    ownerUser?: CompactUser
    creatorUserId?: string
    creatorUser?: CompactUser
    createdAt?: Date
    modifiedAt?: Date
    searchIndex?: string
}

export enum RedirectCallsDateTypes {
    None = 0,
    DateRange = 1,
    WeekDays = 2
}

export enum RedirectCallsRepeatTypes {
    None = 0,
    NoRepeat = 1,
    EveryMonth = 2,
    EveryYear = 3,
    Forever = 4,
    SpecificDate = 5
}

export interface RedirectCallsRangeDateItem {
    from?: Date
    to?: Date
    fromText?: string
    toText?: string
    lastFrom?: Date
    lastTo?: Date
}

export interface RedirectCallsWeekState {
    lastAppliedAt?: string
    lastReleasedAt?: string
}